import React, { useState, useEffect  } from 'react';
import { FaFilePdf, FaChevronRight,FaEnvelope } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import '../styles/NetworkAndConnection.css';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';

import sensorMain from '../assets/product6.png';
import NetworkSensorIMG from '../assets/product6.png';
import NetworkAndConnectionSpecsIMG from '../assets/NetworkAndConnectionSpecsIMG.jpg';


import NetworkSensorPdf from '../assets/NetworkAndConnection.pdf'

export default function NetworkAndConnection() {
  const [activeTab, setActiveTab] = useState('Network');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  return (
    <div className="NetworkAndConnection-wrapper">
      <Header />

      {/* Hero Section */}
      <div className="hero-banner27">
        <div className="hero-banner27-content">
          <h1>Network And Connection</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Network And Connection</span>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <section className="NetworkAndConnectionsensor-intro">
        <div className="NetworkAndConnectionintro-left">
          <img src={sensorMain} alt="NetworkAndConnectionsensor" />
        </div>
        <div className="intro-right">
          <h2>Network And Connection</h2>
          <ul>
            <li>Rich communication interfaces, plug and play, fast configuration</li>
            <li>Data visualization, preventive maintenance</li>
          </ul>
          <div className="intro-buttons">
            <a href={NetworkSensorPdf}  target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
            <button className="download-catalog-btn"><FaFilePdf /> Full Catalog Download</button>
            </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

          </div>
        </div>
      </section>

<div className="Network-wrapper">
    <div className="networkSpecs-image-wrapper">
      <img
        src={NetworkAndConnectionSpecsIMG} // or another image like NetworkSpecsImg
        alt="Network Scanner Specs"
        className="networkSpecs-img"
      />
      {/* <div className="networkSpecs-download-btn">
        <a href={NetworkSensorPdf} target="_blank" rel="noopener noreferrer">
          <button className="download-catalog-btn">
            <FaFilePdf style={{ marginRight: '8px' }} /> Download
          </button>
        </a>
      </div> */}
    </div>
    <br/>
  </div>

      <Footer />
    </div>
  );
}
